/**
 * Calculates the total interest of the mortgage
 * This could be refactored to not need remaining term
 *
 * @param {number} remainingTerm Remaining term in months
 * @param {number} monthlyPayment Monthly payment in pence
 * @param {number} remainingBalance Remaining balance
 *
 * @return {number} Total interest in pence
 *
 */

const getTotalInterest = (args) => {
  // Check arguments
  if (!args.remainingTerm && args.remainingTerm !== 0)
    throw new Error('Remaining term is required');
  if (!args.monthlyPayment && args.monthlyPayment !== 0)
    throw new Error('Monthly payment is required');
  if (!args.remainingBalance && args.remainingBalance !== 0)
    throw new Error('Remaining balance is required');

  const { remainingTerm, monthlyPayment, remainingBalance } = args;

  return remainingTerm * monthlyPayment - remainingBalance;
};

export default getTotalInterest;
